// @flow
import styled from 'styled-components';
import { AccordionTheme } from '../accordion';
import { PanelTheme } from '../accordion/panel';
import GtArrowIcon from '../icons/gt-arrow';
import { daveGrey } from '../colors';
/*::
import type { Node } from 'react';
import type { StyledComponent } from 'styled-components';
import type { ThemeType as AccordionThemeType } from '../accordion';
import type { ThemeType as PanelThemeType } from '../accordion/panel';

export type MainType = {|
  rest?: any,
|}

export type ProcessAccordionThemeType = {|
  Main: StyledComponent<MainType, mixed, HTMLDivElement>
    | React$ComponentType<MainType>,
  SidePadding: StyledComponent<MainType, mixed, HTMLDivElement>
    | React$ComponentType<MainType>,
  ProcessStartIcon: StyledComponent<MainType, mixed, HTMLDivElement>
    | React$ComponentType<MainType>,
  ProcessEndIcon: StyledComponent<MainType, mixed, HTMLDivElement>
    | React$ComponentType<MainType>,
  AccordionTheme: AccordionThemeType,
  Panel: PanelThemeType,
|}
*/

var ProcessIconBase = styled.img.withConfig({
  displayName: "theme__ProcessIconBase",
  componentId: "sc-1q80cw3-0"
})(["position:absolute;left:-8.51rem;width:4.85rem;height:4.85rem;object-fit:contain;"]);
var dashedLineHeight = 8.1;
var theme = {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "sc-1q80cw3-1"
  })(["position:relative;margin:7rem 0;&:before{display:block;background-color:", ";content:'';position:absolute;top:4.2rem;bottom:4.2rem;left:6rem;width:1px;}"], daveGrey(0.7)),
  SidePadding: styled.div.withConfig({
    displayName: "theme__SidePadding",
    componentId: "sc-1q80cw3-2"
  })(["position:relative;margin:0 1.5rem 0 8.2rem;height:1px;"]),
  ProcessStartIcon: styled(ProcessIconBase).withConfig({
    displayName: "theme__ProcessStartIcon",
    componentId: "sc-1q80cw3-3"
  })(["top:", "rem;transform:translateY(-50%);"], 4.2 - dashedLineHeight),
  ProcessEndIcon: styled(ProcessIconBase).withConfig({
    displayName: "theme__ProcessEndIcon",
    componentId: "sc-1q80cw3-4"
  })(["bottom:", "rem;transform:translateY(50%);"], 4.2 - dashedLineHeight),
  AccordionTheme: Object.assign({}, AccordionTheme, {
    Main: styled(AccordionTheme.Main).withConfig({
      displayName: "theme__Main",
      componentId: "sc-1q80cw3-5"
    })(["padding:0 1.5rem 0 8.2rem;"]),
    Panel: Object.assign({}, PanelTheme, {
      Main: styled(PanelTheme.Main).withConfig({
        displayName: "theme__Main",
        componentId: "sc-1q80cw3-6"
      })(["position:relative;&:first-child,&:last-child{&:before{position:absolute;left:-2.62rem;display:block;content:'';width:0.44rem;height:", "rem;border-right:1px dashed ", ";}}&:first-child{&:before{top:", "rem;}}&:last-child{&:before{bottom:", "rem;}}"], dashedLineHeight, daveGrey(0.7), 4.2 - dashedLineHeight, 4.2 - dashedLineHeight)
    })
  }),
  Panel: {
    Main: styled(PanelTheme.Main).withConfig({
      displayName: "theme__Main",
      componentId: "sc-1q80cw3-7"
    })(["position:relative;"]),
    Head: styled(PanelTheme.Head).withConfig({
      displayName: "theme__Head",
      componentId: "sc-1q80cw3-8"
    })(["position:relative;display:flex;justify-content:space-between;font-size:2.4rem;font-weight:400;padding:3rem 0;&:before{position:absolute;top:50%;transform:translateY(-50%);left:-2.67rem;display:block;content:'';width:1.2rem;height:1.1rem;background-color:", ";border-radius:50%;}"], function (pr) {
      return pr.color;
    }),
    ArrowIcon: styled(GtArrowIcon).withConfig({
      displayName: "theme__ArrowIcon",
      componentId: "sc-1q80cw3-9"
    })(["transition:transform 0.3s;transform:rotate(-180deg) !important;[aria-expanded=true] &{transform:rotate(0deg) !important;}"]),
    Body: styled(PanelTheme.Body).withConfig({
      displayName: "theme__Body",
      componentId: "sc-1q80cw3-10"
    })(["font-size:2.4rem;font-weight:200;line-height:150%;padding-bottom:2rem;"]),
    ProcessIcon: styled(ProcessIconBase).withConfig({
      displayName: "theme__ProcessIcon",
      componentId: "sc-1q80cw3-11"
    })(["top:50%;transform:translateY(-50%);"])
  }
};
export default theme;